<header class="header" #headerEl>
  <div class="header-navigation">
    <ul class="header-navigation-menu">
      <li><a (click)="scrollTo('services')">Услуги</a></li>
      <li><a (click)="scrollTo('team')">Специализации</a></li>
      <li><a (click)="scrollTo('projects')">Портфолио</a></li>
      <li><a (click)="scrollTo('questions')">Вопросы</a></li>
      <li><a (click)="scrollTo('contacts')">Контакты</a></li>
    </ul>
    <img
      src="/assets/icons/logo.svg"
      alt="Логотип Зилант"
      class="header-logo"
      width="93"
      height="93"
      loading="lazy"
      #logoEl
    />
    <button (click)="openContactsMenu()" class="discuss-button">
      Обсудить проект
    </button>
    <a href="tel:+79050262162" class="telephone-number"> +7 (905) 026 21 62 </a>
    <img
      src="/assets/Header/burger.svg"
      alt="кнопка бургер-меню"
      class="mobile-burger-menu"
      width="20"
      height="13"
      loading="lazy"
      (click)="toggleBurgerMenu()"
    />
  </div>
</header>
<app-burger-menu
  *ngIf="isBurgerOpen"
  (closeBurgerMenu)="closeBurgerMenu()"
></app-burger-menu>
